export const environment = {
  environmentName: 'test',
  production: true,
  apiUrl: 'https://kbwapitest.azurewebsites.net',
  apiDomain: 'kbwapitest.azurewebsites.net',
  sessionLang: 'lang',
  sessionSelectedTrainingFile: 'selectedTrainingFile',
  sessionSelectedExam: 'selectedExam',
  sessionSelectedTrainingDesc: 'selectedTrainingDesc',
  sessionIsYMUser: 'ymUser',
  requestIdentifier: 'requestIdentifier',
  appInsightsConnectionString: 'InstrumentationKey=fa544a77-7411-42b5-909b-84e14e013dca;IngestionEndpoint=https://germanywestcentral-1.in.applicationinsights.azure.com/;LiveEndpoint=https://germanywestcentral.livediagnostics.monitor.azure.com/;ApplicationId=191034e1-93fd-41c9-b6e6-ad6ead6df384',
  instrumentationKey: 'fa544a77-7411-42b5-909b-84e14e013dca',
  kbkDomain: 'kbktest.kronogroup.com',
  kbwDomain: 'kbwtest.kronogroup.com'
};